export const NEW_ENTITY_TAG_PICKER_GET_TAGS = "NEW_ENTITY_TAG_PICKER_GET_TAGS";
export const NEW_ENTITY_TAG_PICKER_GET_TAGS_RESPONSE = "NEW_ENTITY_TAG_PICKER_GET_TAGS_RESPONSE";